import { SCENE_PROPERTIES, type SceneProperty } from '../../domain/cinematic-property-timeline';
import { TASKS, type Task } from './tasks';
import './studio-task-navigation.css';

export function scenePropertyTask(property?: SceneProperty | null): Task {
  return property === 'mapStyle' || property === 'cameraZoom' || property === 'presentationAppearance' ? 'composition' : 'camera';
}

export const taskSceneProperties = (task: 'camera' | 'composition') => SCENE_PROPERTIES.filter(property => scenePropertyTask(property) === task);

export function StudioTaskNavigation({ task, compact, controlsOpen, inert, onChange }: {
  task: Task; compact: boolean; controlsOpen: boolean; inert: boolean; onChange: (task: Task) => void;
}) {
  return <nav className="studio-task-navigation" aria-label="Composing tasks" inert={inert}>
    {TASKS.map((item, index) => <button type="button" key={item.id} aria-label={item.title} title={item.title}
      aria-current={task === item.id ? 'step' : undefined} aria-controls="composing-controls"
      aria-expanded={compact ? controlsOpen && task === item.id : undefined} onClick={() => onChange(item.id)}>
      <span className="stage-number" aria-hidden="true">{String(index + 1).padStart(2, '0')}</span>
      <span className="stage-full" aria-hidden="true">{item.title}</span><span className="stage-short" aria-hidden="true">{item.shortTitle}</span>
    </button>)}
  </nav>;
}

export function StudioTaskContinue({ task, onChange }: { task: Task; onChange: (task: Task) => void }) {
  const current = TASKS.findIndex(item => item.id === task), next = TASKS[current + 1];
  if (!next) return null;
  return <footer className="studio-task-continue"><span>{current + 1} of {TASKS.length}</span>
    <button type="button" className="primary" onClick={() => onChange(next.id)}>Continue to {next.id === 'export' ? 'review' : next.id}</button>
  </footer>;
}
